const request = require('superagent');

const GET_NEXT = `
  query getNextErssActivity(
    $studentId: String!, $isEarlyReader: Boolean, $isSpanishEarlyReader: Boolean){
      getNextErssActivity(studentId:$studentId, isEarlyReader: $isEarlyReader, isSpanishEarlyReader: $isSpanishEarlyReader){
        nextStories {
          locale
          storyId
        }
        error
    }
  }`;

const GET_STATUS = `
  query status(
    $studentId: String!){
    getErssStatus(studentId: $studentId) {
      domain
      progression{
        skillId
        subSkills {
          skillId
          taken
          current
        }
      }
    }
  }
`
const UPDATE_STATUS = `
  mutation updateStatus(
    $studentId: String!,
    $activityId: String!,
    $tags: [String]
    $status: Status){
      updateErssStatus(studentId: $studentId,activityId: $activityId,tags: $tags, status: $status){
        activityId
        studentId
        skills
        nextSeq
      }
    }
`
export async function getNextErssActivity(studentId,isEarlyReader,isSpanishEarlyReader){
  const data = await graphqlRequest(GET_NEXT,{studentId,isEarlyReader,isSpanishEarlyReader});;
  return data.getNextErssActivity;
}

export async function getErssStatus(studentId){
  const data = await graphqlRequest(GET_STATUS,{studentId});;
  return data.getErssStatus;
}

export async function updateErssStatus(studentId,activityId,tags,status){
  const data = await graphqlRequest(UPDATE_STATUS,{studentId,activityId,tags,status});;
  return data.updateErssStatus;
}

async function graphqlRequest(query, variables) {
  const response = await request.post(process.env.ERSS_ENDPOINT)
    .set('x-api-key', process.env.ERSS_API_KEY)
    .set('Content-Type', 'application/json')
    .send({query: query, variables});
  const {body} = response;

  if (body.errors) {
    console.log(body.errors)
    throw new Error(body.errors[0].message);
  }

  return body.data;
}
